var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconWarming(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_23_3940)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.8397 0.0663147H7.02764L0 7.09395V17.0387L7.02764 23.9337H16.9724L24 16.9061V7.09395L16.8397 0.0663147ZM21.2154 15.8453L15.779 21.2818H8.08838L2.65194 15.8453V8.1547L8.08838 2.71825H15.779L21.2154 8.1547V15.8453Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6077 5.37018H13.2596V14.6519H10.6077V5.37018Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6077 15.9779H13.2596V18.6298H10.6077V15.9779Z",
    fill: "#333333"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_23_3940"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWarming);
export default __webpack_public_path__ + "static/media/icon-warming.257f2b3557837ea0724a074f6f5b663a.svg";
export { ForwardRef as ReactComponent };